import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import ImageLayout, { Container } from 'components/ImageLayout';
import StripeProvider from 'components/StripeProvider';
import CreditCardPage from './CreditCardPage';
import DebitCardPage from './DebitCardPage';

const PublicPaymentPage = () => (
  <StripeProvider>
    <ImageLayout direction="column">
      <Container>
        <Routes>
          <Route path="/:guid/debit_card" element={<DebitCardPage />} />
          <Route path="/:guid/credit_card" element={<CreditCardPage />} />
          <Route path="/*" element={<Navigate to="/" />} />
        </Routes>
      </Container>
    </ImageLayout>
  </StripeProvider>
);

export default PublicPaymentPage;
